"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const common_1 = require("@epic-core/common");
const Message_1 = require("../message/Message");
const PosaRedeemActions_1 = __importDefault(require("../../actions/PosaRedeemActions"));
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const RedeemSectionLoggedInStyled_1 = __importDefault(require("./RedeemSectionLoggedInStyled"));
const Tooltip_1 = __importDefault(require("./Tooltip"));
const VerifyingIconStyled_1 = __importDefault(require("./VerifyingIconStyled"));
const classnames_1 = __importDefault(require("classnames"));
const epic_tracking_1 = __importDefault(require("epic-tracking"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const GiftcardBox_1 = __importDefault(require("./GiftcardBox"));
const RedirectWalletOverlay_1 = __importDefault(require("../overlay/RedirectWalletOverlay"));
const looseMatch = /^[A-Z|a-z|0-9|-]{1,20}$/;
const strictMatch = /^[A-Z|a-z|0-9|-]{16,20}$/;
const validateCode = input => PosaRedeemActions_1.default.validateCode(input);
const onKeyPress = e => {
    const input = e.target.value.trim();
    if (input.length && e.key === 'Enter' && strictMatch.test(input)) {
        validateCode(input);
    }
};
const LoggedInSection = ({ data, posaRedeemStore, accountName, uppercaseCode, prefilledCode, giftcardConfig }) => {
    const { verifying, errorCode } = posaRedeemStore;
    const { loggedInContent, toolTipDescription, toolTipImage } = data;
    const { posaGiftCardRedeemUrl, posaGiftCardCardShow } = giftcardConfig;
    const [value, setValue] = react_1.useState((prefilledCode || '').trim());
    const [validity, toggleValidity] = react_1.useState(true);
    const [showWalletRedirectModal, setShowWalletRedirectModal] = react_1.useState(false);
    const onChange = react_1.useCallback(e => {
        const nextValue = uppercaseCode ? e.target.value.toUpperCase().trim() : e.target.value.trim();
        setValue(nextValue.replace(/[^A-Za-z0-9]/g, ''));
        const isValid = looseMatch.test(nextValue);
        if (isValid && errorCode)
            PosaRedeemActions_1.default.resetErrorCode();
        if (isValid !== validity) {
            if (!isValid && nextValue.length > 15) {
                epic_tracking_1.default.trackEvent('Interaction', {
                    interactionType: 'click',
                    eventCategory: 'PosaRedeem',
                    eventAction: 'codeInvalid',
                    length: nextValue.length
                });
            }
            toggleValidity(!validity);
        }
    }, [errorCode, uppercaseCode]);
    // Handle state(s) when coming back from bfcache — force modal closed
    react_1.useEffect(() => {
        if (typeof window_or_global_1.default !== 'undefined' && window_or_global_1.default.addEventListener) {
            const handlePageShow = event => {
                if (event.persisted) {
                    setShowWalletRedirectModal(false);
                }
            };
            window_or_global_1.default.addEventListener('pageshow', handlePageShow);
            return () => window_or_global_1.default.removeEventListener('pageshow', handlePageShow);
        }
    }, []);
    react_1.useEffect(() => {
        if (errorCode === 'errors.com.epicgames.posa.isWalletCode') {
            setShowWalletRedirectModal(true);
            // Redirect to POSA gift card site in 3s.
            setTimeout(() => {
                window_or_global_1.default.location.href = `${posaGiftCardRedeemUrl}/${value}?lang=${common_1.getLocale()}`;
            }, 3000);
        }
    }, [errorCode]);
    const showError = !validity || errorCode;
    const errorMsg = errorCode && errorCode === Message_1.localizedMessage(errorCode)
        ? Message_1.localizedMessage('errors.com.epicgames.posa.cardNotFound')
        : Message_1.localizedMessage(errorCode !== null && errorCode !== void 0 ? errorCode : '');
    const disabled = !strictMatch.test(value) || verifying;
    const { bgImage, moneyImage } = data;
    const style = react_1.default.useMemo(() => ({
        backgroundImage: `url(${bgImage})`
    }), [bgImage]);
    return (react_1.default.createElement(RedeemSectionLoggedInStyled_1.default, { className: 'ecr-redeemSection loggedIn', style: style },
        react_1.default.createElement("div", { className: "ecrrs-left" },
            react_1.default.createElement("img", { src: moneyImage, alt: "Card" })),
        react_1.default.createElement("div", { className: "ecrrs-right" },
            react_1.default.createElement("div", { className: "ecrrs-loggedIn" },
                react_1.default.createElement(PosaTemplate_1.default, { posaRedeemStore: posaRedeemStore, Tag: "div", string: loggedInContent, isTemplate: true, accountName: accountName }),
                react_1.default.createElement("div", { className: classnames_1.default('input-wrapper', { verifying }) },
                    verifying && react_1.default.createElement(VerifyingIconStyled_1.default, null),
                    react_1.default.createElement("input", { className: classnames_1.default({ error: showError }), type: "text", placeholder: Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.input.placeholder'), value: value, onChange: onChange, onKeyPress: onKeyPress }),
                    react_1.default.createElement(Tooltip_1.default, { content: toolTipDescription, image: toolTipImage })),
                react_1.default.createElement("button", { className: classnames_1.default('btn btn-primary', { disabled }), onClick: () => validateCode(value), disabled: disabled }, Message_1.localizedMessage('epic.code.redemption.posa.page.common.next')),
                react_1.default.createElement("div", { className: classnames_1.default('error-msg', { opaque: showError }) },
                    react_1.default.createElement("span", { className: "msg" }, errorMsg))),
            posaGiftCardCardShow && react_1.default.createElement(GiftcardBox_1.default, { showDesc: true, posaGiftCardRedeemUrl: posaGiftCardRedeemUrl })),
        showWalletRedirectModal ? (react_1.default.createElement(RedirectWalletOverlay_1.default, { image: "https://media-cdn.epicgames.com/8daf628b709c4528931883970208351b/card-art-trimmed.png" })) : null));
};
LoggedInSection.propTypes = {
    data: prop_types_1.default.object,
    posaRedeemStore: prop_types_1.default.object,
    accountName: prop_types_1.default.string,
    uppercaseCode: prop_types_1.default.bool,
    prefilledCode: prop_types_1.default.string,
    giftcardConfig: prop_types_1.default.object
};
exports.default = LoggedInSection;
//# sourceMappingURL=RedeemSectionLoggedIn.js.map